export default function InscriptionConfirmationPage() {
  return (
    <main className="flex-1 flex items-center justify-center px-4 py-20 text-center">
      <div className="max-w-sm">
        <h1 className="text-xl font-bold text-[#07008b] mb-2">Paiement confirmé</h1>
        <p className="text-slate-500 mb-6">
          Votre abonnement est en cours d&apos;activation. Vous recevrez un email dès que votre espace
          pharmacie et votre QR code seront prêts.
        </p>
        <a href="/connexion" className="rounded-lg bg-[#07008b] text-white font-semibold px-5 py-2.5 text-sm">
          Se connecter
        </a>
      </div>
    </main>
  );
}
